import MyPageAlert from './MyPageAlert';
export default MyPageAlert;
